module.exports = __webpack_public_path__ + "static/media/okCheckIcon.264b9d39.webp";